import React from "react";
import { useQuery } from "@apollo/client";
import { ClassroomBooking } from "@models/ISchema";
import { classroomBooking } from "../../graphql/bookingDetail.query";
import BookingCard from "../../components/CardDetail/CardDetail";
import Layout from "../../../../common/layout/Layout";
import CardDetailSkeleton from "@modules/booking/components/CardDetail/CardDetailSkeleton";
import { Text } from "@foris/avocado-suite";
import useBookingContextUrl from "@modules/booking/hooks/useBookingContextUrl";

const BookingDetail = () => {
  const { id, origin, scenario } = useBookingContextUrl();

  const variables = {
    originId: origin,
    scenarioId: scenario,
    bookingId: id,
  };

  const { data, error, loading } = useQuery(classroomBooking, {
    variables,
    fetchPolicy: "network-only",
  });

  const classBooking: ClassroomBooking = data?.cube?.classroomBooking;

  return (
    <Layout contextSearch={false}>
      {!!error && !loading && <Text>No existe reserva</Text>}

      {(loading || !classBooking?.id) && !error && <CardDetailSkeleton />}

      {!loading && !!classBooking?.id && !error && (
        <BookingCard booking={classBooking} campus={scenario} />
      )}
    </Layout>
  );
};

export default BookingDetail;
